





































































































import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { Table, TableHeader } from '@/store/models';

@Component({
  name: 'VTable'
})
export default class VTable extends Vue {
  @Prop({ required: true }) data?: Table;

  get sortStatus() {
    return this.$route.query.order_by;
  }

  get sortType() {
    if (this.sortStatus) return (this.sortStatus as string).charAt(0);
  }

  get sortColumn() {
    if (this.sortStatus) return (this.sortStatus as string).substr(1);
  }

  public resolveProp(obj: any, header: TableHeader) {
    const arr = header.query.split('.');
    if (arr) {
      while (arr.length && (obj = obj[arr.shift() || 0]));
    }
    return obj;
  }

  public getCellText(value: any, header: TableHeader, index: number) {
    if (header.type === 'idx') {
      return index + 1;
    }
    const obj = this.resolveProp(value, header);
    if (header.type === 'status') {
      return obj === 1 ? 'Enabled' : 'Disabled';
    }
    if (header.type === 'percent') {
      return obj + '%';
    }
    return obj;
  }

  public async sort(headerName: string) {
    let status = '+';
    if (this.sortType === '+') status = '-';
    else if (this.sortType === '-') status = '+';

    const query = { ...this.$route.query };
    delete query.offset;
    await this.$router.push({
      path: this.$route.path,
      query: {
        ...query,
        order_by: `${status}${headerName}`
      }
    });
  }

  public getSortIcon(headerName: string) {
    if (this.sortColumn !== headerName) {
      return 'none';
    }

    switch (this.sortType) {
      case '-':
        return 'down';
      case '+':
      default:
        return 'up';
    }
  }
}
